/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Agent_Policy_TabInputs */



/**
* | output |
* | --- |
* | "Agent policy" |
*
* @param {Admin_Settings_Agent_Policy_TabInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_settings_agent_policy_tab = /** @type {((inputs?: Admin_Settings_Agent_Policy_TabInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Agent_Policy_TabInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Agent-Richtlinie")
	return /** @type {LocalizedString} */ ("Agent policy")
});